import {Avatar} from '@mantine/core';
import {MdCollections} from "react-icons/md";

export const RecordIcon = ({
                               size = 'md',
                           }: {
    size?: string
}) => {
    return (
        <Avatar size={size}>
            <MdCollections/>
        </Avatar>
    );
};


